module.exports = __webpack_public_path__ + "static/media/sa.cf69a304.svg";